import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, ComputedRef } from "vue"

// Store
//import store from "@/vue/planning/store/store"

// Enums
import { PaymentCondition } from "@/enums/paymentCondition"

// Components
import FlexiblePaymentCondition from "./FlexiblePaymentCondition.vue"
import FixedPaymentCondition from "./FixedPaymentCondition.vue"


import { useStore } from "vuex"
interface Props {
	paymentCondition: number
	displayTitle: boolean
	cancellationDate: string
	isPVFlex?: boolean
	prestId?: string
	isDisplayPlaceholders?: boolean
	isSummaryDisplay?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentCondition',
  props: {
    paymentCondition: {},
    displayTitle: { type: Boolean },
    cancellationDate: {},
    isPVFlex: { type: Boolean },
    prestId: {},
    isDisplayPlaceholders: { type: Boolean },
    isSummaryDisplay: { type: Boolean }
  },
  setup(__props: any) {

const store = useStore();

// Props
const props = __props

// Computed
const startDate: ComputedRef<string> = computed(() => {
	return store.state.dates.BeginDate || ""
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.paymentCondition === _unref(PaymentCondition).FLEXIBLE)
      ? (_openBlock(), _createBlock(FlexiblePaymentCondition, {
          key: 0,
          displayTitle: props.displayTitle,
          prestId: props.prestId,
          isPVFlex: props.isPVFlex,
          isDisplayPlaceholders: props.isDisplayPlaceholders,
          content: _unref(store).state.content,
          cancellationDate: props.cancellationDate,
          startDate: startDate.value,
          isSummaryDisplay: props.isSummaryDisplay
        }, null, 8, ["displayTitle", "prestId", "isPVFlex", "isDisplayPlaceholders", "content", "cancellationDate", "startDate", "isSummaryDisplay"]))
      : (_openBlock(), _createBlock(FixedPaymentCondition, {
          key: 1,
          displayTitle: props.displayTitle,
          prestId: props.prestId,
          isDisplayPlaceholders: props.isDisplayPlaceholders,
          content: _unref(store).state.content,
          isSummaryDisplay: props.isSummaryDisplay
        }, null, 8, ["displayTitle", "prestId", "isDisplayPlaceholders", "content", "isSummaryDisplay"]))
  ]))
}
}

})